import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoImage from "../../../src/assets/img/logo/DIAG TOKEN.png";
import { scrollToTop } from "../../lib/helpers";
const FooterOne = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbwypXKL8S4xZoWKOuo8yprxSoD47ge4EWJRoPCXuC1Qu176xcttBZvRctg7bXgccHJs/exec";
    try {
      await fetch(scriptURL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ email }),
      });

      setMessage("✅ Email submitted successfully!");
      setEmail("");

      // Hide message after 3 seconds
      setTimeout(() => {
        setMessage("");
      }, 3000);
    } catch (error) {
      setMessage("❌ Failed to submit email.");
      console.error("Error:", error);

      // Hide error message after 3 seconds
      setTimeout(() => {
        setMessage("");
      }, 3000);
    }
  };

  return (
    <footer>
      <div className="footer-area">
        <div className="container">
          <div className="footer-scroll-wrap">
            <button
              className="scroll-to-target"
              data-target="html"
              onClick={scrollToTop}
            >
              <i className="fas fa-arrow-up"></i>
            </button>
          </div>
          <div className="footer-top">
            <div className="row">
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div
                  className="footer-widget wow fadeInUp"
                  data-wow-delay=".2s"
                >
                  <Link to="/" className="f-logo logo">
                    <img src={logoImage} alt="BigTech Logo" />
                  </Link>
                  <div className="footer-content">
                    <p>
                      Diag Token powers the future of AI-driven healthcare.
                      Backed by real-world utility, it rewards users, secures
                      data, and fuels smart diagnostics through the Diagnostica
                      App. Invest in a token with purpose — where crypto meets
                      meaningful impact.
                    </p>
                    <ul className="footer-social">
                      <li>
                        <a
                          href="https://www.facebook.com/DiagToken"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/diag_token"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://x.com/DIAG_Official">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/diag_token"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/@Diag_Token"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://t.me/diagtoken">
                          <i className="fab fa-telegram-plane"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.reddit.com/user/Diag_Official"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <i className="fab fa-reddit-alien"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-5 col-sm-6">
                <div
                  className="footer-widget  wow fadeInUp"
                  data-wow-delay=".4s"
                >
                  <h4 className="fw-title">Useful Links</h4>
                  <div className="footer-link merriweather-sans">
                    <ul>
                      {/* <li>
                        <Link to="/presale">Contact us</Link>
                      </li> */}
                      {/* <li>
                        <Link to="https://diagnostica.app" target="_blanck">
                          About Us
                        </Link>
                      </li> */}
                      <li>
                        <Link to="/privacy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/terms">Terms & Conditions</Link>
                      </li>
                      <li>
                        <Link to="/cookie">Cookie Policy</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-3 col-sm-6">
                <div
                  className="footer-widget wow fadeInUp"
                  data-wow-delay=".6s"
                >
                  <h4 className="fw-title">Community</h4>
                  <div className="footer-link merriweather-sans">
                    <ul>
                      <li>
                        <Link
                          to="https://humb-global-healthtech-india-pvt-ltd.odoo.com/diaghealth.support"
                          target="_blank"
                        >
                          Help Center
                        </Link>
                      </li>
                      <li>
                        <Link to="/blog">Blog</Link>
                      </li>
                      {/* <li>
                        <Link to="/">Newsletters</Link>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6">
                <div
                  className="footer-widget wow fadeInUp"
                  data-wow-delay=".8s"
                >
                  <h4 className="fw-title">Subscribe to the DIAG Newsletter</h4>
                  <div className="footer-newsletter">
                    <p className="merriweather-sans">
                      Get early access to token updates, AI-health
                      breakthroughs, and exclusive community rewards — straight
                      to your inbox.
                    </p>
                    <form id="emailForm" onSubmit={handleSubmit}>
                      <input
                        type="email"
                        id="emailInput"
                        placeholder="Enter Your Email ID"
                        className="merriweather-sans"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <button type="submit">
                        <i className="fas fa-envelope"></i>
                      </button>

                      {message && (
                        <p
                          style={{
                            marginTop: "8px",
                            color: message.startsWith("✅") ? "green" : "red",
                            fontSize: "14px",
                          }}
                        >
                          {message}
                        </p>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="row align-items-center">
              <div className="col-12">
                <div className="copyright-text text-center">
                  <p>Copyright &copy; 2025 Diagnostica. All Rights Reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
